import { MapTypeStatus } from '@src/core/controllers/map/entities';

export const DEFAULT_GOOGLE_MAP_ZOOM = 10;
export const DEFAULT_GOOGLE_MAP_LATITUDE = 43.238949;
export const DEFAULT_GOOGLE_MAP_LONGITUDE = 76.889709;
export const DEFAULT_GOOGLE_MAP_TYPE = MapTypeStatus.ROADMAP;

export const SELECTED_GOOGLE_MAP_ZOOM = 18;

export const MAP_CENTER_STORAGE_KEY = 'asend.google.maps.center.key';
export const MAP_TYPE_ID_STORAGE_KEY = 'asend.google.maps.type.id.key';

export const ARC_GOOGLE_MAP_KEY = 'arc.google.map.key';

export const ARC_MAP_EVENT =  {
  onDblClick: 'dblclick',
};

